//TODO someday: fetch the popup instead of having the HTML in the dom
//SHARED FILE : USED ON DETAILS AND PRODUCT LIST
const FavoriteDropdown4i = function(){	
	let popup,
	
	init = () => {
		document.getElementById("mainContent").addEventListener("click", events);
	},
	events = e => {
		let el = e.target;
		if(e.target.classList.contains("faveLink")){
			e.preventDefault();
			open(el);
		}else if(e.target.classList.contains("cancel-delete-item")){
			e.preventDefault();
			removeMsg();
			document.querySelector('.ideaBoardList').querySelector("button").focus();
		}else if(e.target.classList.contains("confirm-delete-item")){
			e.preventDefault();
			deleteTheItem(el);
		}else if(e.target.classList.contains("cancelBoardList")){
			e.preventDefault();
			closeOpenDropdown(true);
		}else if(e.target.classList.contains("boardName")){
			e.preventDefault();
			addToExistingBoard(el);
		}
	},
	removeMsg = () => {
		if(document.querySelector(".addToBoardMsg")) document.querySelector(".addToBoardMsg").remove();
	},
	deleteTheItem = el => {
		let arr = el.getAttribute('href').split('/');
		fetchDeleteBoardItem(arr[0], arr[1], el);
	},
	trapFocus = (e, el) => {
		e.preventDefault();
		e.stopPropagation();
		el.parentNode.parentNode.querySelector(".cancelBoardList").focus();
	},
	closeOpenDropdown = (setFocus) =>{
		if(!document.querySelector(".ideaBoardList").classList.contains("hide")){
			let favIcon = document.querySelector(".ideaBoardList").previousElementSibling;
			favIcon.setAttribute("aria-expanded", "false");
			document.querySelector(".ideaBoardList").remove();
			if(setFocus == true) favIcon.focus();
		}
	},
	keyEvents = e => {
		if ((e.which || e.keyCode) === 27) closeOpenDropdown(true);
		else if (e.keyCode == 9 && e.target.classList.contains("viewAllFavs")) trapFocus(e, e.target);
	},
	open = heartIcon =>{
		if (popup == undefined || popup == "") popup = document.querySelector('.favDropdownTemplate').innerHTML; 
		closeOpenDropdown(false);
		heartIcon.insertAdjacentHTML('afterend', popup);
		
		let boardDropDown = document.querySelector('.ideaBoardList');
		heartIcon.setAttribute("aria-expanded", "true");
    		boardDropDown.classList.add("slideDown");
    		boardDropDown.classList.remove("hide");
    		boardDropDown.setAttribute("aria-hidden", "false");
    		boardDropDown.querySelector(".cancelBoardList").focus();
    		
    		boardDropDown.removeEventListener('keydown', keyEvents);
    		boardDropDown.addEventListener('keydown', keyEvents);
    		
    		let prodName = heartIcon.querySelector(".prodNameFavsBoard").innerHTML;
    		let existingBoards = [].slice.call(boardDropDown.querySelectorAll(".addToBoardProdName"));
    		existingBoards.forEach((el) => {
    			el.innerHTML = prodName;
    		});
	},
	addToExistingBoard = boardName =>{
		removeMsg();
		fetchAddToIdeaBoard(boardName);
	},
	turnFavOn = (heartIcon) => {
		heartIcon.classList.remove("textLtGray");
		heartIcon.classList.add("textRed");
	},
	turnFavOff = (heartIcon) => {
		heartIcon.classList.remove("textRed");
		heartIcon.classList.add("textLtGray");
	},
	fetchAddToIdeaBoard = el => {
		let boardIDNumber = el.parentNode.querySelector('.board-id').value,
		productID = (typeof (prodID) == 'undefined') ? el.closest('.faveLinkWrapper').parentNode.querySelector('.faveLinkProdID').value : prodID,
		loading = el.parentNode.querySelector('.addItemLoading');
		
		if (productID == null) productID = document.getElementById('productid').value;		
		loading.classList.remove("hide");
		
		fetch('/favs/additemtoboard', { 
        		method: 'POST', 
        		body: JSON.stringify({ boardID: boardIDNumber, productID: productID }), 
        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function(response){
			return  (response.ok) ? response.json() : []; // response.json() returns a promise
		}).then(function(response){
			loading.classList.add("hide");
        		if (response.success == "true") {
        			let heartIcon = el.closest('.faveLinkWrapper').querySelector('.faveLink');
        			turnFavOn(heartIcon);
        			el.insertAdjacentHTML('afterend', response.message);
            			el.nextElementSibling.querySelector("a").focus();
        		}
		});
	},
	fetchDeleteBoardItem = (e, f, el) => { 
		let boardID = e,
		boardItemID = f,
		removeBtn = el,
		loading = el.parentNode.parentNode.parentNode.querySelector('.addItemLoading');
		
		loading.classList.remove("hide");
		
		fetch('/favs/deleteboarditem', { 
        		method: 'POST', 
        		body: JSON.stringify({ boardID: boardID, boardItemID: boardItemID }), 
        		headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function(response){
			return  (response.ok) ? response.json() : []; // response.json() returns a promise
		}).then(function(response){
                	loading.classList.add("hide");
                	if (response.isItemInOtherBoards == "False") {
                		let heartIcon = removeBtn.closest('.faveLinkWrapper').querySelector('.faveLink');
                		turnFavOff(heartIcon);
          		}
          		removeMsg();
          		document.querySelector('.ideaBoardList').querySelector("button").focus();
            	});
	};
	
	return {
		Init: init
	};
};

(function(){
	const favoriteDropDown = new FavoriteDropdown4i();
	favoriteDropDown.Init();
})();